module.exports = __webpack_public_path__ + "static/media/slider-fit.b0c398fe.jpg";